<template>
  <div>
    <el-upload
      action=""
      :auto-upload="false"
      list-type="picture-card"
      :on-change="uploadFile"
      :file-list="fileLists"
      accept="video/mp4, video/ogg, video/flv,video/avi,video/wmv,video/rmvb"
      :headers="headers"
      :disabled="fileLists.length >= limit || uploadBtn">
      <i slot="default" class="el-icon-plus"></i>
      <div slot="file" slot-scope="{file}">
        <video class="el-upload-list__item-thumbnail" :src="file.url" alt=""></video>
        <span class="el-upload-list__item-actions">
          <span class="el-upload-list__item-preview" @click="handleShowVideo(file)">
              <i class="el-icon-video-play"></i>
          </span>
<!--          <span class="el-upload-list__item-edit" @click="handleEditVideo(file)">-->
<!--              <i class="el-icon-edit"></i>-->
<!--          </span>-->
          <span class="el-upload-list__item-delete" @click="handleRemove(file)">
              <i class="el-icon-delete"></i>
          </span>
        </span>
        <el-progress type="circle" class="progressModule" :color="colors" :percentage="Number(uploadPercentage)" v-if="showProgress && file.url == uploadUrl"></el-progress>
      </div>
    </el-upload>

    <el-dialog :visible.sync="dialogVisible" append-to-body width="40%" style="text-align:center">
      <video :src="dialogImageUrl" alt="" autoplay class="video" controls="controls"></video>
    </el-dialog>
    <el-dialog :visible.sync="editView" width="40%" append-to-body>
      <el-input type="textarea" :rows="4" v-model="editForm.url" @input="editVideo"></el-input>
    </el-dialog>
  </div>
</template>

<script>
import { uploadFile } from "../../api/goods/index"
export default {
  name: "video-upload",
  props:{
    limit:{
      type:Number,
      default: 5,
    },
    action:{
      type:String,
      default:'#'
    },
    fileList:{
      type:Array,
      default: ()=>{
        return []
      }
    },
  },
  watch: {
    fileList: {
      handler(newVal, oldVal) {
        console.log('this.fileList', newVal)
        this.fileLists = newVal;
      },
      // 代表在wacth里声明了firstName这个方法之后立即先去执行handler方法
      immediate: true
    }
  },
  data() {
    return {
      headers: { "Content-Type": "multipart/form-data" },
      dialogImageUrl: '',
      dialogVisible: false,
      fileLists: [],
      editForm:{
        url:'',
        uid:null
      },
      editView:false,
      username:'',
      uploadPercentage:0,
      showProgress:false,
      uploadUrl:'',
      colors: [
        {color: '#ADD8E6', percentage: 20},
        {color: '#87CEEB', percentage: 40},
        {color: '#87CEFA', percentage: 60},
        {color: '#00BFFF', percentage: 80},
        {color: '#1296DB', percentage: 100}
      ],
      uploadBtn:false,
    }
  },
  methods: {
    async uploadFile(file, fileList) {
        try {
        console.log(file)
        this.uploadBtn = true
        this.uploadUrl = file.url
        this.showProgress = true
        this.uploadPercentage = file.percentage.toFixed(0)
        let fileList1 = [];
        let FormDatas = new FormData()
        FormDatas.append('file',file.raw);
        let { data } = await uploadFile(FormDatas);
        console.log('data', data)
        if(data && data.code === 200) {
          this.showProgress = false
          this.uploadBtn = false
          this.uploadPercentage += 100;
          this.$message.success(this.$t('AAAA.uploadSuccess'))
          let obj = {
            domain: data.data.domain,
            status: "success",
            name: data.data.name,
            originalName: data.data.originalName,
            url: data.data.link,
          }
          this.fileLists.push(obj)
          this.submitFile()
        }else {
          for(var i =0;i < fileList1.length;i++){
            if(i+1 == fileList1.length){
              fileList1.splice(i,1)
            }
          }
          this.$message.error(data.msg)
          return
        }
      } catch (e) {
        console.log(e);
        this.$message.error(e.toString())
      }
    },
    // 移除视频
    handleRemove(file) {
      for(let i in this.fileLists){
        if(this.fileLists[i].uid == file.uid){
          this.fileLists.splice(i,1)
        }
      }
      this.submitFile()
    },
    handleShowVideo(file) {
      console.log(file)
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    // 播放视频
    handleEditVideo(file){
      this.editForm.url = file.url
      this.editForm.uid = file.uid
      this.editView = true
    },
    // 编辑视频
    editVideo(){
      for(let i in this.fileLists){
        if(this.fileLists[i].uid == this.editForm.uid){
          this.fileLists[i].url = this.editForm.url
        }
      }
      this.submitFile()
    },
    // 将图片文件传回给父组件
    submitFile(){
      this.$emit('uploadVideos',this.fileLists)
    },
  }
}
</script>

<style lang="scss" scoped>
.el-icon-plus{
  font-size: 30px!important;
}
.el-icon-edit{
  font-size: 18px !important;
}
.el-icon-video-play{
  font-size: 18px !important;

}
.el-icon-delete{
  font-size: 18px !important;
  color:rgb(243, 143, 130);
}
.el-input>>> .el-textarea__inner{
  font-size:18px!important;
}
.video{
  width: 80%;
  object-fit: cover;
}
.progressModule >>> .el-progress__text{
  color:#1296DB;
  font-size: 15px!important;
}
</style>
